/*
 * @Description:
 * @Version: 2.0
 * @Autor: lijunyan
 * @Date: 2021-04-12 10:48:44
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2021-11-28 15:33:05
 */
/**
 * @Author: WeiZisen
 * @Date: 2021-04-06 10:38:50
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-05-25 10:41:40
 * @Description: 用户登录接口
 * @FilePath: \Design_Vue_pmp\src\api\login\index.js
 */
import request from '@/utils/request';

//@设计平台登陆登录
export function userLogin(data) {
  return request({
    url: '/Users/Login',
    method: 'post',
    data,
  });
}

//@ 获取登录用户信息
export function getUserDetails() {
  return request({
    url: '/Users/GetUserInfo',
    method: 'get',
  });
}

/**
 * @description: 根据登录人 获取可以查看的项目
 * @param {*} user  如果登陆人是 领导 或者 管理员，可以看到所有项目， 否则，只能看到先关项目
 * @return {*}
 */
export function getPrjListbyUser(data) {
  return request({
    url: '/Tree/GetPrjtree',
    method: 'post',
    data,
  });
}

//@ 根据登录人 获取可以查看的项目
export function getPrjListbyUserMarket(data) {
  return request({
    url: '/Tree/GetPrjtreeMarket',
    method: 'post',
    data,
  });
}

//@ 根据登录人 获取可以查看的项目
export function getPrjListbyUserDesign(data) {
  return request({
    url: '/Tree/GetPrjtreeDesign',
    method: 'post',
    data,
  });
}

/**
 * @description:  根据登录人+项目 查询人员的  角色+专业
 * @param {*} data 登录人+项目 { prjId, userId}
 * @return {*}角色+专业
 */
export function getprjRoleInfoAPI(data) {
  return request({
    url: '/Users/getprjRoleInfo',
    method: 'get',
    params: data,
  });
}
